export const SET_LOADING_API = 'setLoadingApi';
